/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEqual } from 'lodash';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import LegalPicker from 'shared/ui/components/form-components/pickers/LegalPicker.vue';
import PlatformPdfDocuments from './legal/PlatformPdfDocuments.vue';

const __vue_script__ = {
    name: 'BrandedAppLegal',

    components: { Checkbox, LegalPicker, PlatformPdfDocuments },

    props: {
        brandingId: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            branding: undefined,
            changed: false,
            legalDocs: [],
            legalPdfUrls: {},
            orgId: undefined,
            showCookieBanner: false,
            showFoss: false,
        };
    },

    async mounted() {
        await this.getBranding();
        this.orgId = this.branding.fp_owner;
        if (this.branding.legal_documents?.length) {
            this.legalDocs = [...this.branding.legal_documents];
        }
        if (this.branding.legal_pdfs_urls) {
            this.legalPdfUrls = { ...this.branding.legal_pdfs_urls };
        }
        const activationPages = this.branding.activation_pages || {};
        this.showCookieBanner = Boolean(activationPages.show_cookie_banner);
        this.showFoss = Boolean(activationPages.show_foss);
    },

    methods: {
        async getBranding() {
            try {
                this.branding = await this.$services.branding.getBranding(this.brandingId);
            } catch (err) {
                console.error(`[BrandedAppLegal] failed to get branding for ${this.brandingId}`);
                throw err;
            }
        },

        getChanges() {
            const legalDocsChanged = !isEqual(this.legalDocs.map(d => d._id), this.branding.legal_documents);
            const legalPdfsChanged = !isEqual(this.legalPdfUrls, this.branding.legal_pdfs_urls);
            const cookieChanged = !isEqual(this.showCookieBanner, this.branding.activation_pages?.show_cookie_banner);
            const fossChanged = !isEqual(this.showFoss, this.branding.activation_pages?.show_foss);

            this.changed = legalDocsChanged || legalPdfsChanged || cookieChanged || fossChanged;

            return { legalDocsChanged, legalPdfsChanged, cookieChanged, fossChanged };
        },

        onChange() {
            this.getChanges();
        },

        async onSave() {
            const branding = { ...this.branding };
            const { legalDocsChanged, legalPdfsChanged, cookieChanged, fossChanged } = this.getChanges();
            if (legalDocsChanged) {
                branding.legal_documents = this.legalDocs.map(d => d._id);
            }
            if (legalPdfsChanged) {
                branding.legal_pdfs_urls = this.legalPdfUrls;
            }
            if (cookieChanged) {
                branding.activation_pages = {
                    ...(branding.activation_pages || {}),
                    show_cookie_banner: this.showCookieBanner,
                };
            }
            if (fossChanged) {
                branding.activation_pages = {
                    ...(branding.activation_pages || {}),
                    show_foss: this.showFoss,
                };
            }

            try {
                await this.$services.branding.updateBrandingDoc(branding);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('legal_documents.editor.doc_saved').toString(),
                    type: 'success',
                });

                await this.getBranding();
                this.getChanges();
            } catch (error) {
                console.error('[BrandedAppLegal] Could not save changes:', error);
                this.$notify({
                    group: 'flashes',
                    text: error.message,
                    type: 'error'
                });
            }
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orgId
    ? _c(
        "div",
        { staticClass: "branded-app-legal" },
        [
          _c("legend", [
            _vm._v(
              _vm._s(_vm.$t("legal_documents.app.legal_requirements.title"))
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("legal_documents.app.legal_requirements.info"))
            ),
          ]),
          _c("validation-provider", {
            attrs: { slim: true, name: "legal_documents" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    return [
                      _c("legal-picker", {
                        attrs: {
                          name: "legal_documents",
                          "org-name": _vm.orgId,
                          label: _vm.$t(
                            "general_settings.form.legal_documents"
                          ),
                          placeholder: _vm.$t(
                            "general_settings.form.legal_documents_placeholder"
                          ),
                          errors: errors,
                        },
                        on: { input: _vm.onChange },
                        model: {
                          value: _vm.legalDocs,
                          callback: function ($$v) {
                            _vm.legalDocs = $$v
                          },
                          expression: "legalDocs",
                        },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              2760446993
            ),
          }),
          _c("a", { attrs: { href: "/org/" + this.orgId + "/legal" } }, [
            _c("button", { staticClass: "btn" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "legal_documents.app.legal_requirements.create_new_document"
                  )
                )
              ),
            ]),
          ]),
          _c("legend", [
            _vm._v(
              _vm._s(_vm.$t("legal_documents.app.legal_pdf_documents.title"))
            ),
          ]),
          _c("div", { staticClass: "alert alert-info" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("legal_documents.app.legal_pdf_documents.alert_1")
                )
              ),
            ]),
            _c("br"),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("legal_documents.app.legal_pdf_documents.alert_2")
                )
              ),
            ]),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("legal_documents.app.legal_pdf_documents.info"))
            ),
          ]),
          _c("validation-provider", {
            attrs: { slim: true, name: "legal_pdfs_urls" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    return [
                      _vm.orgId
                        ? _c("platform-pdf-documents", {
                            attrs: { orgId: _vm.orgId },
                            on: { input: _vm.onChange },
                            model: {
                              value: _vm.legalPdfUrls,
                              callback: function ($$v) {
                                _vm.legalPdfUrls = $$v
                              },
                              expression: "legalPdfUrls",
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              1096740776
            ),
          }),
          _c("legend", [
            _vm._v(
              _vm._s(_vm.$t("legal_documents.app.show_cookie_banner.title"))
            ),
          ]),
          _c("validation-provider", {
            attrs: { slim: true, name: "show_cookie_banner" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    return [
                      _c("checkbox", {
                        attrs: {
                          label: _vm.$t(
                            "legal_documents.app.show_cookie_banner.label"
                          ),
                          name: "show_cookie_banner",
                          errors: errors,
                        },
                        on: { input: _vm.onChange },
                        model: {
                          value: _vm.showCookieBanner,
                          callback: function ($$v) {
                            _vm.showCookieBanner = $$v
                          },
                          expression: "showCookieBanner",
                        },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              4168015585
            ),
          }),
          _c("legend", [
            _vm._v(_vm._s(_vm.$t("legal_documents.app.show_foss.title"))),
          ]),
          _c("validation-provider", {
            attrs: { slim: true, name: "show_foss" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    return [
                      _c("checkbox", {
                        attrs: {
                          label: _vm.$t("legal_documents.app.show_foss.label"),
                          name: "show_foss",
                          errors: errors,
                        },
                        on: { input: _vm.onChange },
                        model: {
                          value: _vm.showFoss,
                          callback: function ($$v) {
                            _vm.showFoss = $$v
                          },
                          expression: "showFoss",
                        },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              315544120
            ),
          }),
          _vm.changed
            ? _c("secondary-toolbar", [
                _c(
                  "button",
                  { staticClass: "btn btn-primary", on: { click: _vm.onSave } },
                  [_vm._v(_vm._s(_vm.$t("general.save_changes")))]
                ),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/branded-app/BrandedAppLegal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__